export default __webpack_public_path__ + "static/laffayette_comic_pro-webfont-30e19fafda975fd8b8213fac36fe7744.woff2";